// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FontColorOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 512 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M221.63 109L109.92 392h58.05l24.08-61h127.9l24.08 61h58.05L290.37 109zm-8.26 168L256 169l42.63 108z","fill":"currentColor"}}]},"name":"font-color","theme":"outlined"};

const FontColorOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FontColorOutlinedSvg} />;
  FontColorOutlined.displayName = 'FontColorOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FontColorOutlined);
